import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=c07d7126&scoped=true"
import script from "./myAccount.vue?vue&type=script&lang=js"
export * from "./myAccount.vue?vue&type=script&lang=js"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=c07d7126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07d7126",
  null
  
)

export default component.exports